import React, { ButtonHTMLAttributes, forwardRef } from 'react';
import cx from 'clsx';

import styles from './styles.module.scss';

export enum ButtonVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
}

const VARIANT_STYLE_MAP: Record<ButtonVariant, string | undefined> = {
  [ButtonVariant.PRIMARY]: styles.primary,
  [ButtonVariant.SECONDARY]: styles.secondary,
  [ButtonVariant.TERTIARY]: styles.tertiary,
};

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & Readonly<{
  variant?: ButtonVariant;
  destructive?: boolean;
  testId?: string;
}>;

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  variant = ButtonVariant.PRIMARY,
  destructive,
  className,
  testId,
  ...props
}, ref) => (
  <button
    ref={ref}
    className={cx(
      styles.button,
      VARIANT_STYLE_MAP[variant],
      { [styles.destructive]: destructive },
      className
    )}
    {...props}
    data-testid={testId || 'BUTTON_TEST_ID'}
  />
));
